import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-quantity-selector',
    templateUrl: './quantity-selector.component.html',
    styleUrl: './quantity-selector.component.scss',
})
export class QuantitySelectorComponent implements OnInit {
    @Input() label: string | null = null;
    @Input() withControl: boolean = false;
    @Input() value: number = 1;
    @Input() allowNegative = false;
    @Input() mask = '';
    @Input() suffix = '';
    @Output() changed = new EventEmitter<number>();

    convertedValue: number;

    public ngOnInit(): void {
        this.changed.emit(parseInt(this.value.toString()));
    }

    public eventChanged(event: Event): void {
        let element = (event.target as HTMLInputElement);
        let actualValue = parseInt(element.value);

        if (actualValue !== this.convertedValue) {
            this.convertedValue = actualValue;
            this.changed.emit(this.convertedValue);
        }
    }
    public eventControlClicked(valueToAdd: number): void {
        this.value += valueToAdd;
        this.changed.emit(this.value);
    }
}
